import { ClientBoard } from '../../../model/client-model/client-board';
import { ClientNode } from '../../../model/client-model/client-node';
import { BoardViewModel } from '../../../store/board/board.types';

export function isClientBoard(
  board: ClientBoard | ClientNode | BoardViewModel['pathways/transition-hierarchy']
): board is ClientBoard {
  return !!(board as ClientBoard).boardSettings;
}
